// @ts-nocheck
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Color, SidebarProgressBar, SidebarProgressList, SidebarProgressListItem } from '@figure/frontlib-gui';
import { Typography, CspButton } from 'shared/components';
import { usePersonalLoan, useProfile } from 'shared/hooks';
import PersonalLoanStateMachine from 'state-machines/PersonalLoanStateMachine';
import { sidebarStateLogic } from './sidebar-state-logic';
import SidebarOfferDetails from './OfferDetails';

const SidebarTitle = styled(Typography.BodyBold)`
  color: ${Color.TEAL};
`;

const OnboardingSidebar = () => {
  const { personalLoan } = usePersonalLoan();
  const { profile, getProfile } = useProfile(false);
  const isAuthenticated = useSelector(({ identityReducer }) => identityReducer.jwt?.length > 0);
  const [currentStateMap, setCurrentStateMap] = useState({});

  const isReselect =
    personalLoan.status?.uwSubDecision === 'VERIFIED_DTI_LIMITED' || personalLoan.status?.uwSubDecision === 'VERIFIED_OFFER';

  useEffect(() => {
    if (isAuthenticated && !profile.uuid) getProfile();
  }, [isAuthenticated, getProfile, profile.uuid]);

  useEffect(() => {
    if (personalLoan?.status) {
      const state = PersonalLoanStateMachine.run(profile, personalLoan);
      setCurrentStateMap(sidebarStateLogic(state));
    }
  }, [personalLoan, profile]);

  const shouldDisplayTalkToCsa =
    personalLoan.status !== undefined && personalLoan.status.bypassKycReview !== undefined && !personalLoan.status.bypassKycReview;

  return (
    <SidebarProgressBar>
      <SidebarTitle>Application Progress</SidebarTitle>

      <SidebarProgressList>
        <SidebarProgressListItem active={true} complete={currentStateMap?.BASIC_INFO?.complete}>
          Basic info
        </SidebarProgressListItem>
        <SidebarProgressListItem active={currentStateMap?.SELECT_OFFER?.active} complete={currentStateMap?.SELECT_OFFER?.complete}>
          Select offer
        </SidebarProgressListItem>
        <SidebarProgressListItem
          active={currentStateMap?.ADDITIONAL_INFO?.active}
          complete={currentStateMap?.ADDITIONAL_INFO?.complete}
        >
          Provide more info
        </SidebarProgressListItem>
        <SidebarProgressListItem
          active={currentStateMap?.VERIFY_IDENTITY?.active}
          complete={currentStateMap?.VERIFY_IDENTITY?.complete}
        >
          Verify identity
        </SidebarProgressListItem>
        <SidebarProgressListItem active={currentStateMap?.INCOME?.active} complete={currentStateMap?.INCOME?.complete}>
          Link income sources
        </SidebarProgressListItem>
        <SidebarProgressListItem active={currentStateMap?.DOCUMENTS?.active} complete={currentStateMap?.DOCUMENTS?.complete}>
          Sign documents
        </SidebarProgressListItem>
        {shouldDisplayTalkToCsa && (
          <SidebarProgressListItem active={currentStateMap?.CSA?.active} complete={currentStateMap?.CSA?.complete}>
            Talk to CSA
          </SidebarProgressListItem>
        )}
      </SidebarProgressList>
      <SidebarOfferDetails selectedOffer={personalLoan?.selectedOffer} hideSelectedOffer={isReselect} />

      {/** For Development: Displays button to open current app in CSP - Hides if node_env is production */}
      <CspButton identityUuid={personalLoan.identityUuid} plUuid={personalLoan.uuid} />
    </SidebarProgressBar>
  );
};

export default OnboardingSidebar;
